<snelstart-ui-dialog-definition [(visible)]="this.dialogVisible"
                                [useTitleBorder]="false"
                                id="ki"
                                size="extraLarge"
                                title="Klantinstellingen">

  <snelstart-ui-dialog-body [padding]="0">
    <snelstart-ui-tab>
      <snelstart-ui-tab-item
        (click)="onSelectTab(0)"
        [isActive]="this.tabIndex === 0"
        id="firstTab"
      >
        Algemeen
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(1)"
        [isActive]="this.tabIndex === 1"
        id="secondTab"
      >
        Contact
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(2)"
        [isActive]="this.tabIndex === 2"
        id="thirdTab"
      >
        SnelStart administraties
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(3)"
        [isActive]="this.tabIndex === 3"
        id="sixthTab"
      >
        Externe administraties
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(4)"
        [isActive]="this.tabIndex === 4"
        id="forthTab"
      >
        Belastingplicht
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(5)"
        [isActive]="this.tabIndex === 5"
        id="fifthTab"
      >
        Jaarrapportage
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(6)"
        [isActive]="this.tabIndex === 6"
        id="sixthTab"
      >
        Uitstel
      </snelstart-ui-tab-item>
    </snelstart-ui-tab>
    <snelstart-ui-tab-content>
      @if (tabIndex === 0) {
        <div [formGroup]="customerFormGroup">
          <snelstart-ui-text-form-control [disabledControl]="true"
                                          [required]=true
                                          class="custom-input-250"
                                          formControlName="name"
                                          id="name"
                                          label="Naam*"
          >
          </snelstart-ui-text-form-control>
          <snelstart-ui-text-form-control [disabledControl]="true"
                                          class="custom-input-250"
                                          formControlName="kvk"
                                          id="kvk"
                                          label="KVK-nummer*"
          >
          </snelstart-ui-text-form-control>
          <snelstart-ui-bsn-form-control [disabledControl]=true
                                         class="me-1 custom-input-250"
                                         formControlName="fiscalIdentifier"
                                         id="taxId"
                                         label="Fiscaal nummer*"
          >
          </snelstart-ui-bsn-form-control>
        </div>
        <p class="pt-3" style="font-weight: lighter">
          Wijzig deze gegevens in SnelStart Relaties (Polaris).
        </p>
      }

      @if (tabIndex === 1) {
        <div [formGroup]="customerFormGroup">
          <div formGroupName="address">
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            class="custom-input-250"
                                            formControlName="streetName"
                                            id="streetName"
                                            label="Straat"
            >
            </snelstart-ui-text-form-control>
            <div class="row">
              <div class="col-auto" style="padding-right: 4px">
                <snelstart-ui-text-form-control [disabledControl]="true"
                                                class="custom-input-60"
                                                formControlName="streetNumber"
                                                id="streetNumber"
                                                label="Huisnr."
                >
                </snelstart-ui-text-form-control>
              </div>
              <div class="col-auto">
                <snelstart-ui-text-form-control [disabledControl]="true"
                                                class="custom-input-50"
                                                formControlName="affix"
                                                id="affix"
                                                label="Toev."
                >
                </snelstart-ui-text-form-control>
              </div>
              <div class="col-auto">
                <snelstart-ui-text-form-control [disabledControl]="true"
                                                class="custom-input-100"
                                                formControlName="postalCode"
                                                id="postalCode"
                                                label="Postcode"
                >
                </snelstart-ui-text-form-control>
              </div>
            </div>
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            class="custom-input-250"
                                            formControlName="city"
                                            id="city"
                                            label="Plaats"
            >
            </snelstart-ui-text-form-control>
          </div>
          <snelstart-ui-text-form-control [disabledControl]="true"
                                          class="custom-input-250"
                                          formControlName="phoneNumber"
                                          id="phoneNumber"
                                          label="Telefoonnummer vast"
          >
          </snelstart-ui-text-form-control>
          <snelstart-ui-text-form-control [disabledControl]="true"
                                          class="custom-input-250"
                                          formControlName="mobileNumber"
                                          id="mobileNumber"
                                          label="Telefoonnummer mobiel"
          >
          </snelstart-ui-text-form-control>
          <snelstart-ui-email-form-control [disabledControl]="true"
                                           class="custom-input-250"
                                           formControlName="emailAddressLine"
                                           id="emailAddressLine"
                                           label="E-mailadres"
          >
          </snelstart-ui-email-form-control>
        </div>

        <p class="pt-3" style="font-weight: lighter">
          Wijzig deze gegevens in SnelStart Relaties (Polaris).
        </p>
      }

      @if (tabIndex === 2) {
        <div [formGroup]="administrationsFormGroup">
          <div formArrayName="administrations">
            @for (administrationFormGroup of this.administrationsFormGroup.controls.administrations.controls; track administrationFormGroup; let index = $index) {
              <div [formGroupName]="index">
                @if (administrationFormGroup.controls.administrationId.value != null && administrationFormGroup.controls.name.value != null) {
                  <div class="row mb-0.5">
                    <div class="col-auto">
                      <snelstart-ui-text-form-control [disabledControl]="true"
                                                      [label]="index === 0 ? 'SnelStart administraties' : ''"
                                                      class="custom-input-250"
                                                      formControlName="name"
                                                      [id]="`administration-${index + 1}-name`"
                      >
                      </snelstart-ui-text-form-control>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-button (click)="removeAdministrationFormGroup(index)"
                                           [class]="index === 0 ? 'pt-3' : ''"
                                           icon="trash"
                                           iconType="light"
                                           size="medium"
                                           type="secondary"
                                           [id]="`delete-administration-${index + 1}-button`"
                      >
                      </snelstart-ui-button>
                    </div>
                  </div>
                } @else {
                  <div class="row mb-0.5">
                    <div class="col-auto">
                      <snelstart-ui-select-form-control (change)="this.selectSnelStartAdministration(index);"
                                                        [label]="index === 0 ? 'SnelStart administratie' : ''"
                                                        [options]="(this.administrationOptions$ | async) ?? []"
                                                        class="col-auto custom-input-250"
                                                        formControlName="administrationId"
                                                        [id]="`administration-${index + 1}-id`"
                      >
                      </snelstart-ui-select-form-control>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-button (click)="removeAdministrationFormGroup(index)"
                                           [class]="$index === 0 ? 'pt-3' : ''"
                                           class="col-auto"
                                           icon="trash"
                                           iconType="light"
                                           size="medium"
                                           type="secondary"
                                           [id]="`delete-administration-${index + 1}-button`"
                      >
                      </snelstart-ui-button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <snelstart-ui-button (click)="addAdministrationFormGroup()"
                               [disabled]="!(this.canAddAdministrationFormGroup$ | async)"
                               class="snelstart-ui-button"
                               icon="plus"
                               id="add-administration-button"
                               type="link">Administratie toevoegen
          </snelstart-ui-button>
        </div>
      }

      @if (tabIndex === 3) {
        @if (this.hasBalanceProviderAdministration()) {
          <snelstart-ui-alert type="info">
            Per client kan er 1 externe administratie worden gekoppeld. Er is al een externe
            administratie gekoppeld, waardoor het koppelen van een administratie nu niet mogelijk is. Om
            een nieuwe administratie te koppelen, dient de bestaande koppeling te worden verwijderd. Dit
            kan onder het tabblad 'Administraties'.
          </snelstart-ui-alert>
        } @else {
          <snelstart-venture-fiscaal-domain-logic-balance-provider-administration-selection-dialog
            (administrationSelected)="this.balanceProviderAdministrationSelected($event)"
          />
        }
      }

      @if (tabIndex === 4) {
        <div [formGroup]="clientFormGroup">
          @if (client$ | async; as client) {
            @if (client.corporateTax !== true) {
              <snelstart-ui-select-form-control [options]="this.booleanOptions"
                                                [required]=true
                                                class="custom-input-250"
                                                formControlName="incomeTax"
                                                id="incomeTax"
                                                label="Belastingplicht inkomstenbelasting"
              >
              </snelstart-ui-select-form-control>
            }

            @if (client.incomeTax !== true) {
              <snelstart-ui-select-form-control [options]="this.booleanOptions"
                                                [required]=true
                                                class="custom-input-250"
                                                formControlName="corporateTax"
                                                id="corporateTax"
                                                label="Belastingplicht vennootschapsbelasting"
              >
              </snelstart-ui-select-form-control>
            }
          }
          <snelstart-ui-select-form-control [options]="this.booleanOptions"
                                            [required]=true
                                            class="custom-input-250"
                                            formControlName="valueAddedTax"
                                            id="valueAddedTax"
                                            label="Belastingplicht omzetbelasting"
          >
          </snelstart-ui-select-form-control>
          @if (this.clientFormGroup.controls.valueAddedTax.value) {
            <snelstart-ui-text-form-control [required]="this.clientFormGroup.controls.valueAddedTax.value"
                                            class="custom-input-250"
                                            formControlName="taxIdVat"
                                            id="taxIdVat"
                                            label="Omzetbelastingnummer"
            >
              <snelstart-ui-form-control-error-message type="pattern">
                Ongeldig omzetbelastingnummer
              </snelstart-ui-form-control-error-message>
            </snelstart-ui-text-form-control>
          }
          <snelstart-ui-select-form-control [options]="this.booleanOptions"
                                            [required]=true
                                            class="custom-input-250"
                                            formControlName="wageTax"
                                            id="wageTax"
                                            label="Inhoudingsplicht loonbelasting"
          >
          </snelstart-ui-select-form-control>
          @if (this.clientFormGroup.controls.wageTax.value) {
            <snelstart-ui-text-form-control [required]="this.clientFormGroup.controls.wageTax.value"
                                            class="custom-input-250"
                                            formControlName="taxIdWageTax"
                                            id="taxIdWageTax"
                                            label="Loonheffingennummer"
            >
              <snelstart-ui-form-control-error-message type="pattern">
                Ongeldig loonheffingennummer
              </snelstart-ui-form-control-error-message>
            </snelstart-ui-text-form-control>
          }
        </div>
      }
      @if (tabIndex === 5) {
        <div [formGroup]="clientFormGroup">
          <snelstart-ui-select-form-control [options]="this.sbiCodeOptions"
                                            class="custom-input-250"
                                            formControlName="sbiCode"
                                            id="sbiCode"
                                            label="SBI-code"
          >
          </snelstart-ui-select-form-control>
          <snelstart-ui-select-form-control [options]="this.bedrijfsklasseOptions"
                                            class="custom-input-250"
                                            formControlName="classificatie"
                                            id="classificatie"
                                            label="Bedrijfsklasse"
          >
          </snelstart-ui-select-form-control>
        </div>
      }

      @if (tabIndex === 6) {
        @if ((intermediary$ | async)?.certValidUntil !== null) {
          <div style="width: 75%">
            <snelstart-ui-alert type="info">
              Geef onderstaand aan of deze klant opgenomen moet worden in de uitstel (beconregeling). De lijst met
              uitstelverzoeken en voortgang, alsmede het afmelden van klanten voor de
              uitstelregeling, vind je op de pagina 'Uitstelregeling'.
            </snelstart-ui-alert>
          </div>
          <div [formGroup]="clientFormGroup">
            <snelstart-ui-select-form-control [options]="this.booleanOptions"
                                              [required]=true
                                              class="custom-input-250"
                                              formControlName="postponement"
                                              id="postponement"
                                              label="Opnemen in uitstel (beconregeling)"
            >
            </snelstart-ui-select-form-control>
          </div>
        } @else {
          <div style="width: 75%">
            <snelstart-ui-alert type="info">
              De kantoorgegevens van je kantoororganisatie zijn nog niet volledig ingevuld. <br/>
              Voor het toepassen van de Beconregeling zijn een beconnummer, een RSIN en een
              PKI-certificaat nodig.
            </snelstart-ui-alert>
          </div>
        }
      }
    </snelstart-ui-tab-content>

  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button (click)="this.dialogVisible.set(false);"
                         class="me-1"
                         btn-x
                         id="cancel"
                         type="secondary"
    >Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button (click)="saveForm(true)"
                         icon="check"
                         id="save"
                         type="primary">
      Opslaan
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
